<template>
  <div>

    <v-navigation-drawer  dark temporary :right="right" v-model="guestLeftDrawer" app
                         class="primary guest-nav-menu" style="z-index: 999;">

<!--      <v-toolbar color="primary lighten-1" >-->
        <v-flex class="gutter-mobile-header primary" />

        <v-list dark class="primary  v-toolbar" >
          <v-list-tile avatar>


            <v-list-tile-avatar  >
              <v-img src="static/images/avatar180x.jpg"></v-img>
            </v-list-tile-avatar>

            <v-list-tile-content >
              <v-list-tile-title>Guest User</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn color="white" outline @click="openRoute('Login')"
                     v-if="!['/login','/'].includes($route.path) && !isAuth && $store.state.device.isMobile === false">
                Sign in</v-btn>
              <v-btn color="white" outline  @click="openSignUp()"
                     v-if="['/login','/'].includes($route.path) && $store.state.device.isMobile === false"
                     >Sign up</v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      <v-flex xs12 pa-2 pb-2 class="hidden-sm-and-down">
        <v-switch
          v-model="mobile"
          label="Mobile view"
          color="white"
          class="mt-0"
          hide-details
        ></v-switch>
      </v-flex>
<!--      </v-toolbar>-->

      <v-list class="pt-0 primary darken-1" dense>
        <v-list-tile>
          <v-list-tile-content>
            <Translate />
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>

        <div v-for="(item, index) in items"
             :key="item.title">

        <v-list-group
          v-if="typeof item.items !== 'undefined' && item.isActive === true && item.isActive === true"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list-group>

          <v-list-tile
            v-if="item.routeName &&
            typeof item.items === 'undefined' &&
            item.isActive === true"
            :key="item.title" :class="item.routeName === $route.name ? 'selectedRoute' :'' "
            @click="openRoute(item.routeName)"
          >

            <v-list-tile-content >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-else-if="item.divider" :key="index"></v-divider>
          <v-subheader v-else-if="item.header" :key="item.header" class="grey--text text--lighten-4">
            {{ item.header}}
          </v-subheader>
        </div>
      </v-list>
      <v-spacer></v-spacer>
      <div style="right:10px;position:fixed;"
           class="px-2 grey--text text--lighten-1">Build: v{{version}}.{{clientVersion[0]}}</div>
      <div style="width:100%;bottom:50px;position:fixed;text-align: center"><img :src="anabIcon" height="100" alt="ANAB ACCREDITED"/></div>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import Translate from '../Translate.vue'
  import packageConfig from '../../../package.json'

  export default {
    name: 'GuestLeftNavigationMenu',
    components: {
      Translate
    },
    data () {
      return {
        anabIcon: require('@/assets/logos/ANAB-transparent.png'),
        version: localStorage.getItem('version'),
        clientVersion: packageConfig.version.split('.').reverse(),
        right: true,
        hasAvatar: true,
        items: [
          {
            routeName: 'Home',
            title: 'Home',
            isActive: true
          },
          { divider: true },
          {
            routeName: 'CertificateProgram',
            title: 'Certificate program',
            isActive: true
          },
          { divider: true },
          // {
          //   routeName: 'Faq',
          //   title: 'Frequently asked questions',
          //   isActive: true
          // },
          // { divider: true },
          {
            routeName: 'PrivacyPolicy',
            title: 'Privacy policy',
            isActive: true
          },
          { divider: true },
          {
            routeName: 'TermsOfUse',
            title: 'Terms of use',
            isActive: true
          },
          { divider: true },
          {
            routeName: 'AnsiAccreditation',
            title: 'ANSI-ANAB Accreditation',
            isActive: true
          },
          { divider: true }
        ]
      }
    },
    computed: {
      mobile: {
        get: function () {
          return !this.$store.getters.getIPad
        },
        set: function (newValue) {
          this.$store.commit('setIPad', !newValue)
        }
      },
      guestLeftDrawer: {
        get: function () {
          return this.$store.getters.guestLeftDrawer
        },
        set: function (value) {
          this.$store.commit('toggleGuestLeftDrawer', value)
        }
      },
      isAuth () {
        return this.$auth.check()
      }
    },
    methods: {
      openRoute (route) {
        this.guestLeftDrawer = false
        this.$router.push({name: route})
      },
      openSignUp () {
        this.guestLeftDrawer = false
        this.$router.push({name: 'SignUp', params: {step: 'confirm-my-email'}})
      },
      countrySelected () {
        // eslint-disable-next-line no-console
        console.log('Country selected')
        this.dialog = false
      },
      countrySelected1 () {
        // eslint-disable-next-line no-console
        console.log('Country countrySelected1')
      }
    }
  }
</script>
<style scoped lang="stylus">
  .selectedRoute {
    background : rgba(255,255,255,0.12)
    cursor: default
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/GuestLeftNavigationMenu.vue